import React from 'react';

function Logo({ size = 56, showTagline = true, light = false }) {
  const textColor = light ? '#92400e' : '#f5d08a';
  const taglineColor = light ? '#b45309' : '#d97706';

  // Rõngad: kaks ringi, suur ühisosa, vasak pool logost
  const r = size * 0.48;          // rõnga raadius
  const cx1 = r + 2;              // vasak rõngas — jätab vasakul täpselt r ruumi
  const cx2 = r * 1.9 + 2;       // parem rõngas (suur kattumine)
  const cy = r + 2;               // vertikaalne keskkond
  const svgW = cx2 + r + 4;
  const svgH = r * 2 + 4 + 4;

  // Südameke suurus ja asukoht (ühisosa keskel)
  const hx = (cx1 + cx2) / 2;
  const hy = cy;
  const hs = r * 0.38; // südameke suurus

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: '14px',
      background: 'linear-gradient(135deg, #022c22 0%, #064e3b 100%)',
      borderRadius: '16px',
      padding: '14px 24px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    }}>

      {/* SVG — rõngad vasakul */}
      <svg width={svgW} height={svgH} viewBox={`0 0 ${svgW} ${svgH}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="leftRing">
            <circle cx={cx1} cy={cy} r={r} />
          </clipPath>
          <clipPath id="rightRing">
            <circle cx={cx2} cy={cy} r={r} />
          </clipPath>
          <linearGradient id="goldFill" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#fef3c7" />
            <stop offset="60%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#b45309" />
          </linearGradient>
          <linearGradient id="ringStroke" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#fde68a" />
            <stop offset="100%" stopColor="#92400e" />
          </linearGradient>
        </defs>

        {/* Vasak rõngas — tühi sisu */}
        <circle cx={cx1} cy={cy} r={r} stroke="url(#ringStroke)" strokeWidth="1.4" fill="none" />
        {/* Parem rõngas — tühi sisu */}
        <circle cx={cx2} cy={cy} r={r} stroke="url(#ringStroke)" strokeWidth="1.4" fill="none" />

        {/* Ühisosa — kuldne täidis (vasak rõngas lõigab parema) */}
        <circle cx={cx2} cy={cy} r={r} clipPath="url(#leftRing)" fill="url(#goldFill)" opacity="0.88" />

        {/* Punane südameke ühisosas */}
        <path
          d={`
            M ${hx} ${hy + hs * 0.55}
            C ${hx} ${hy + hs * 0.55} ${hx - hs * 0.7} ${hy + hs * 0.1} ${hx - hs * 0.7} ${hy - hs * 0.2}
            C ${hx - hs * 0.7} ${hy - hs * 0.6} ${hx - hs * 0.35} ${hy - hs * 0.72} ${hx} ${hy - hs * 0.28}
            C ${hx + hs * 0.35} ${hy - hs * 0.72} ${hx + hs * 0.7} ${hy - hs * 0.6} ${hx + hs * 0.7} ${hy - hs * 0.2}
            C ${hx + hs * 0.7} ${hy + hs * 0.1} ${hx} ${hy + hs * 0.55} ${hx} ${hy + hs * 0.55} Z
          `}
          fill="#dc2626"
          opacity="0.95"
        />
      </svg>

      {/* Tekst paremal — kui showTagline=true, INOROFF + slogan KÕRVUTI (mitte all),
          et kogu logo+slogan jääks ühte kompaktsesse rohelisesse kasti.
          Slogan kasutab oma fikseeritud font'i (mitte size'iga proportsionaalne),
          et väikeste size'ide juures (23/35) jääks loetav. */}
      <div style={{
        display: 'flex',
        flexDirection: showTagline ? 'row' : 'column',
        alignItems: showTagline ? 'center' : 'flex-start',
        gap: showTagline ? '12px' : '0',
      }}>
        <span style={{
          fontSize: `${size * 0.72}px`,
          fontWeight: '900',
          color: textColor,
          textTransform: 'uppercase',
          fontFamily: 'Georgia, "Times New Roman", serif',
          lineHeight: 1,
          display: 'block',
          whiteSpace: 'nowrap',
        }}>
          INOROFF
        </span>
        {showTagline && (
          <span style={{
            fontSize: size < 40 ? '10px' : '13px',
            color: taglineColor,
            letterSpacing: '0.3px',
            fontFamily: "'Segoe UI', Arial, sans-serif",
            fontStyle: 'italic',
            lineHeight: 1.25,
            display: 'block',
            maxWidth: size < 40 ? '110px' : '180px',
          }}>
            Where desires and differences meet
          </span>
        )}
      </div>
    </div>
  );
}

export default Logo;
